import React from "react";
import { Link } from "react-router-dom";

/**
 * /avanzo/practica — micropráctica (bloques cortos de 5/8/10 preguntas).
 * En Fase 3 la lógica delega en /avanzo/entrenar; aquí sólo se
 * presentan los bloques y la CTA. El motor pedagógico está listo para
 * modo TRAINING; extenderlo a "practice_block" es futuro.
 */
export default function AvanzoPractice() {
  const blocks = [
    { size: 5, label: "Práctica rápida", desc: "5 preguntas · ~5 min" },
    { size: 8, label: "Práctica media",  desc: "8 preguntas · ~10 min" },
    { size: 10, label: "Práctica enfocada", desc: "10 preguntas · ~15 min" },
  ];
  return (
    <div data-testid="avz-practice">
      <section className="avz-card">
        <h1 className="avz-h1">Microprácticas</h1>
        <p className="avz-lead">
          Elige un bloque corto y adaptamos las preguntas a las habilidades que estás fortaleciendo.
          No hay presión: puedes detenerte cuando quieras.
        </p>
      </section>

      <section className="avz-grid avz-grid-2 avz-mt-4">
        {blocks.map((b) => (
          <div className="avz-card" key={b.size} data-testid={`avz-practice-block-${b.size}`}>
            <h3 className="avz-h3">{b.label}</h3>
            <p className="avz-mute">{b.desc}</p>
            <Link
              to="/avanzo/entrenar"
              className="avz-btn avz-btn-primary avz-mt-4"
              data-testid={`avz-practice-start-${b.size}`}
            >
              Comenzar
            </Link>
          </div>
        ))}
      </section>

      <section className="avz-card avz-mt-8">
        <h3 className="avz-h3">¿Prefieres seguir tu ritmo?</h3>
        <p className="avz-mute">También puedes usar Entrenar para practicar sin bloques.</p>
        <Link
          to="/avanzo/entrenar"
          className="avz-btn avz-btn-secondary avz-mt-4"
          data-testid="avz-practice-freeform"
        >
          Ir a Entrenar
        </Link>
      </section>
    </div>
  );
}
